import { Icon, IconProps } from "../";

export const HomeIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M13.8136 3.91692C12.7759 3.00653 11.2241 3.00653 10.1864 3.91692L3.77691 9.54007C2.96533 10.2521 2.5 11.2793 2.5 12.359V19.2501C2.5 20.2166 3.2835 21.0001 4.25 21.0001H7.75C8.7165 21.0001 9.5 20.2166 9.5 19.2501V17.5001C9.5 16.1193 10.6193 15.0001 12 15.0001C13.3807 15.0001 14.5 16.1193 14.5 17.5001V19.2501C14.5 20.2166 15.2835 21.0001 16.25 21.0001H19.75C20.7165 21.0001 21.5 20.2166 21.5 19.2501V12.359C21.5 11.2793 21.0347 10.2521 20.2231 9.54007L13.8136 3.91692Z" />
    </Icon>
  );
};
